// File: ../routes/getActivityBookings.ts (o simile)

import { Call } from "../../../api/apiCall";
// Assumendo che ActivityBookingDetails sia definita e importata qui
import { ActivityBookingDetails } from "../model/ActivityBookingDetails"; 

// Nota: Il tipo di ritorno corretto è ActivityBookingDetails[]
export const getActivityBookingDetails = async (
    ExternalBookingId?: number,
    ExternalActivityId?: number,
    fromdate?: string,
    todate?: string,
    Channel?: string
): Promise<ActivityBookingDetails[]> => { // <-- CORREZIONE DEL TIPO DI RITORNO
    try {
        const payload = {
            ExternalBookingId: ExternalBookingId,
            ExternalActivityId: ExternalActivityId,
            fromdate: fromdate,
            todate: todate,
            Channel: Channel
        };

        const res = await Call("bookings/getActivityBookings", "post", payload); 

        if (res.ok) {
            // CORREZIONE: Restituisce i dati parsati, non l'oggetto Response
            return await res.json() as ActivityBookingDetails[]; 
        } else {
            const errorData = await res.json();
            console.error("Errore API lato server:", errorData);
            throw new Error(errorData.message || `Errore server: ${res.status}`);
        }
    } catch (error) {
        console.error("Errore di rete o server non raggiungibile:", error);
        throw new Error(error instanceof Error ? error.message : "Impossibile connettersi al servizio di ricerca.");
    }
};
